<template>
  <header id="header" class="header-dynamic header-light header-shadow-scroll">
    <div class="container">
      <router-link class="logo" :to="`/${$i18n.locale}`">
        <img src="@/assets/img/logo.png" alt />
      </router-link>
      <nav>
        <ul class="nav-primary">
          <li v-for="item in navItems" :key="item.name">
            <router-link :to="item.path">{{ item.name }}</router-link>
            <ul v-if="item.sub">
              <li v-for="subItem in item.sub" :key="subItem.name">
                <router-link :to="subItem.path">{{ subItem.name }}</router-link>
              </li>
            </ul>
          </li>
          <LanguageSwitch />
        </ul>
      </nav>
    </div>
    <Slide right push class="mobile-nav">
      <ul class="nav-mobile">
        <LanguageSwitch />
        <li class="list-mobile" v-for="item in navItems" :key="item.name">
          <router-link :to="item.path">{{ item.name }}</router-link>
          <ul v-if="item.sub" class="sub-list">
            <li v-for="subItem in item.sub" :key="subItem.name">
              <router-link :to="subItem.path">{{ subItem.name }}</router-link>
            </li>
          </ul>
        </li>
      </ul>
    </Slide>
  </header>
</template>
<script>
import { Slide } from "vue-burger-menu";
import LanguageSwitch from "@/components/layout/LanguageSwitch";

export default {
  components: { Slide, LanguageSwitch },
  computed: {
    navItems() {
      return [
        {
          name: this.$t("nav.about"),
          path: `/` + this.$i18n.locale + `/greetings`,
          sub: [
            {
              name: this.$t("nav.aboutSub.greetings"),
              path: `/` + this.$i18n.locale + `/greetings`
            },
            {
              name: this.$t("nav.aboutSub.goals"),
              path: `/` + this.$i18n.locale + `/goals`
            }
          ]
        },
        {
          name: this.$t("nav.news"),
          path: `/` + this.$i18n.locale + `/news`
        },
        {
          name: this.$t("nav.membership"),
          path: `/` + this.$i18n.locale + `/membership`
        },
        {
          name: this.$t("nav.services"),
          path: `/` + this.$i18n.locale + `/services`
        },
        {
          name: this.$t("contact"),
          path: `/` + this.$i18n.locale + `/contact`
        }
      ];
    }
  }
};
</script>
